module.exports = __webpack_public_path__ + "home/en-US/images/abcmouse_draggable-dd8a8100600393ce0ea4f313298f9369.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/abcmouse_draggable.png
// module id = XBNP
// module chunks = 0